import { Component, OnInit, Inject } from '@angular/core';
import { ScheduleModel } from './schedule.model';
import { ScheduleService } from './schedule.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CalendarComponent } from './calendar.component';
import { ContactService } from '../contact/contact/contact.service';
import { ContactModel } from '../contact/contact/contact.model';
import { UntypedFormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { ConceptModel } from '../concept/concept/concept.model';

@Component({
    selector: 'app-new-event-dialog',
    templateUrl: './new-event-dialog.component.html',
    styleUrls: ['./calendar.component.css'],
    standalone: false
})
export class NewEventDialogComponent implements OnInit {

    contactControl = new UntypedFormControl();
    filteredContacts!: Observable<ContactModel[]>;

    conceptControl = new UntypedFormControl();
    filteredConcepts!: Observable<ConceptModel[]>;

    constructor(
        private scheduleService: ScheduleService,
        public dialogRef: MatDialogRef<CalendarComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,

        private contactService: ContactService
    ) { }

    contacts: ContactModel[] = this.data.contacts;
    newEvent: ScheduleModel = this.data.newEvent;
    concepts: ConceptModel[] = this.data.concepts;

    ngOnInit(): void {
        this.newEvent.startDate = this.data.newEvent.startDate;
        this.newEvent.endDate = this.data.newEvent.endDate;

        // this.filteredContacts = this.contactControl.valueChanges.pipe(
        //     startWith(''),
        //     map(value => this._filterContacts(value || ''))
        // );

        // this.filteredConcepts = this.conceptControl.valueChanges.pipe(
        //     startWith(''),
        //     map(value => this._filterConcepts(value || ''))
        // )

    }

    // private _filterContacts(value: string): ContactModel[] {
    //     const filterValue = (value || '').toLowerCase();
    //     return this.contacts.filter(c =>
    //         ((c.companyName && c.companyName.toLowerCase()) || '').includes(filterValue)
    //     );
    // }

    // private _filterConcepts(value: string): ConceptModel[] {
    //     const filterValue = (value || '').toLowerCase();
    //     return this.concepts.filter(c =>
    //         ((c.name && c.name.toLowerCase()) || '').includes(filterValue)
    //     );
    // }

    // selectContact(name: string) {
    //     const contact = this.contacts.find(c => c.companyName === name);
    //     if (contact) {
    //         this.newEvent.contactUid = contact.uid;
    //         this.contactControl.setValue(contact.companyName);
    //     }
    // }

    // selectConcept(name: string) {
    //     const concept = this.concepts.find(c => c.name === name);
    //     if (concept) {
    //         this.newEvent.conceptUid = concept.uid;
    //         this.conceptControl.setValue(concept.name);
    //     }
    // }

    save() {
        // var conceptText = this.conceptControl.value ? this.conceptControl.value.trim() : '';
        const matchedConcept = this.concepts.filter(c => c.uid == this.newEvent.conceptUid)[0];

        if (matchedConcept) {
            this.newEvent.conceptUid = matchedConcept.uid;
        } else {
            this.newEvent.conceptUid = '00000000-0000-0000-0000-000000000000';
            this.newEvent.description = (this.newEvent.description || '');
            this.newEvent.observations = (this.newEvent.observations || '') + '\nConcepto libre: ' + this.newEvent.conceptUid;
        }

        if (this.newEvent.id > 0) {
            this.scheduleService.update(this.newEvent).subscribe(() => {
                this.close();
            });
        } else {
            this.scheduleService.create(this.newEvent).subscribe(() => {
                this.close();
            });
        }
    }

    close() {
        this.dialogRef.close();
    }
  public trackByIndex(i: number) { return i; }

}
